$(".menu-toggle").click(function(){
    $(".mb-float").toggleClass('left0');
    $("html").toggleClass('overflow')
});

if (window.matchMedia("(max-width: 1199px)").matches) 
{
    $(".left-nav_dropdown").on("click", function(e){
        e.preventDefault();
        $(this).parent("li").find(".nav-second").slideToggle()
    });

}
